import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
    selector: 'kt-assignment',
    templateUrl: './assignment.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssignmentComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}
